const Timsort = require("timsort");
/**
 * Get the average of multiple numbers
 * @param {Array<object>} data - Array of object that needs to be sort
 * @return {number} Return a number representing the average
 */
const getAverage = data => {
	let average = 0;
	average = data / data.length(); // SUM OF DATA
	return average;
};

/**
 * Calculates a date given the parameter, with today date as base
 * @param {number} minus - Number of month to retrieve from current month
 * @return {Date} date
 */
const getDate = minus => {
	let y = minus || 0;
	let today = new Date();
	let day = today.getDate();
	let month = today.getMonth();
	let year = today.getFullYear();
	let date = new Date(year, month, day);
	date.setMonth(date.getMonth() - y);
	return date.getMonth() + 1;
};

/**
 * @type {Array<date>}
 */
const sortedMonth = [
	getDate(11),
	getDate(10),
	getDate(9),
	getDate(8),
	getDate(7),
	getDate(6),
	getDate(5),
	getDate(4),
	getDate(3),
	getDate(2),
	getDate(1),
	getDate()
];

export default {
	methods: {
		/**
		 * Sort the data to retrieve a keyword position every month
		 * @param {Array<object>} data - Array of object that needs to be sort
		 * @return {Array<object>} Return an array object of the sorted keyword for each month
		 */
		sortKeywordPosition: data => {
			// SORT KEYWORD ONLY
			let sortedKeyword = [];
			let savedKeyword = [];
			for(var i = 0; i < Object.keys(data).length; i++) {
				let keyword = "";
				if(!savedKeyword.includes(data[i].keys[0])) {
					sortedKeyword.push({
						key: data[i].keys[0],
						data: []
					});
					keyword = data[i].keys[0];
					savedKeyword.push(keyword);
				}
			}
			// SORT POSITION FOR KEYWORD
			for(var j = 0; j < savedKeyword.length; j++) {
				for(var y = 0; y < sortedMonth.length; y++) {
					let posSum = 0;
					let count = 0;
					for(var k = 0; k < Object.keys(data).length; k++) {
						if(
							data[k].keys[0] == savedKeyword[j] &&
              data[k].keys[1].slice(5, 7) == sortedMonth[y]
						) {
							posSum += data[k].position;
							count += 1;
						}
					}
					if(count == 0) {
						sortedKeyword[j].data.push({
							month: sortedMonth[y],
							pos: 0
						});
					}
					else{
						sortedKeyword[j].data.push({
							month: sortedMonth[y],
							pos: posSum / count
						});
					}
				}
			}

			// GET STATUS POS EACH MONTH
			let finalData = [];
			for(var x = 0; x < sortedMonth.length; x++) {
				let rank1 = 0;
				let rank2 = 0;
				let rank3 = 0;
				for(var z = 0; z < sortedKeyword.length; z++) {
					if(
						sortedKeyword[z].data[x].pos >= 1 &&
            sortedKeyword[z].data[x].pos <= 3
					) {
						rank1 += 1;
					}
					if(
						sortedKeyword[z].data[x].pos >= 4 &&
            sortedKeyword[z].data[x].pos <= 10
					) {
						rank2 += 1;
					}
					if(
						sortedKeyword[z].data[x].pos >= 5 &&
            sortedKeyword[z].data[x].pos <= 100
					) {
						rank3 += 1;
					}
				}
				finalData.push({
					1: rank1,
					2: rank2,
					3: rank3
				});
			}

			return sortedKeyword;
		},

		/**
		 * Sort the data to retrieve a keyword position every month
		 * @param {Array<object>} data - Array of object that needs to be sort
		 * @return {Array<object>} Return an array object of the sorted keyword for each month
		 */
		sortKeywordPositionBis: data => {
			let sortedKeyword = [];
			let savedKeyword = [];
			// RETRIEVE EACH KEYWORD IN A NEW ARRAY
			for(var i = 0; i < Object.keys(data).length; i++) {
				let keyword = "";
				if(!savedKeyword.includes(data[i].keys[0])) {
					sortedKeyword.push({
						key: data[i].keys[0],
						data: []
					});
					keyword = data[i].keys[0];
					savedKeyword.push(keyword);
				}
			}

			// SORT LAST POSITION FOR EACH MONTH
			for(var j = 0; j < savedKeyword.length; j++) {
				for(var y = 0; y < sortedMonth.length; y++) {
					let allPos = [];
					let lastIndexSaved = 0;
					let lastPos = 0;
					let reverseData = data.reverse();
					let length = Object.keys(data).length;
					for(var k = length - 1; k >= 0; k--) {
						if(
							reverseData[k].keys[0] == savedKeyword[j] &&
              reverseData[k].keys[1].slice(5, 7) == sortedMonth[y]
						) {
							if(reverseData[k].position > 0) {
								// If an index has been saved we can delete it so that it doesn't loop through it again
								if(lastIndexSaved != 0) {
									reverseData.splice(lastIndexSaved, 1);
									length--;
								}
								/*
								 * Push the value in the array (will be used after)
								 * And save the index to delete it after (looking for speed)
								 */
								allPos.push(reverseData[k].position);
								lastIndexSaved = k;
							}
						}
					}
					// Retrieve the last element (the data are given by date and only the lastest one interest us (for each month))
					lastPos = allPos.pop();
					if(lastPos == 0 || isNaN(lastPos)) {
						sortedKeyword[j].data.push({
							month: sortedMonth[y],
							pos: 0
						});
					}
					else{
						sortedKeyword[j].data.push({
							month: sortedMonth[y],
							pos: lastPos
						});
					}
				}
			}
			// GET RANK POS EACH MONTH
			let rankedData = [];
			for(var x = 0; x < sortedMonth.length; x++) {
				let rank1 = 0;
				let rank2 = 0;
				let rank3 = 0;
				for(var z = 0; z < sortedKeyword.length; z++) {
					if(
						sortedKeyword[z].data[x].pos >= 1 &&
            sortedKeyword[z].data[x].pos <= 3
					) {
						rank1 += 1;
					}
					if(
						sortedKeyword[z].data[x].pos >= 4 &&
            sortedKeyword[z].data[x].pos <= 10
					) {
						rank2 += 1;
					}
					if(
						sortedKeyword[z].data[x].pos >= 5 &&
            sortedKeyword[z].data[x].pos <= 100
					) {
						rank3 += 1;
					}
				}
				rankedData.push({
					1: rank1,
					2: rank2,
					3: rank3
				});
			}
			// SORT THE DATA TO SUITS FOR THE COLUMN BAR CHART
			let finalData = [];
			let arr1 = [];
			let arr2 = [];
			let arr3 = [];
			for(var e = 0; e < rankedData.length; e++) {
				arr1.push(rankedData[e][1]);
				arr2.push(rankedData[e][2]);
				arr3.push(rankedData[e][3]);
			}
			finalData.push({
				rank1: arr1,
				rank2: arr2,
				rank3: arr3,
				totalForKeyword: sortedKeyword
			});
			return finalData;
		},

		/**
		 * Sort the data to retrieve a keyword position every month
		 * @param {Array<object>} data - Array of object that needs to be sort
		 * @param {string} keyword - Keyword to check
		 * @return {Array<number>} Return an array containing the position of the keyword each month (sorted by month starting at january)
		 */
		sortOneKeywordPosition: (data, keyword) => {
			let sortedKeyword = {
				key: keyword,
				data: []
			};
			let keywordYearlyPos = {
				imp: [],
				clicks: [],
				ctr: [],
				pos: []
			};
			// SORT LAST POSITION FOR EACH MONTH
			for(var y = 0; y < sortedMonth.length; y++) {
				let allPos = [];
				let lastIndexSaved = 0;
				let lastPos = 0;
				let reverseData = data.reverse();
				let length = Object.keys(data).length;
				let clic = 0;
				let impressions = 0;
				let ctr = 0;
				let count = 0;
				for(var k = length - 1; k >= 0; k--) {
					if(reverseData[k].keys[1].slice(5, 7) == sortedMonth[y]) {
						if(reverseData[k].position > 0) {
							// If an index has been saved we can delete it so that it doesn't loop through it again
							if(lastIndexSaved != 0) {
								reverseData.splice(lastIndexSaved, 1);
								length--;
							}
							/*
							 * Push the value in the array (will be used after)
							 * And save the index to delete it after (looking for speed)
							 */
							allPos.push(
								Number.parseFloat(reverseData[k].position).toFixed(2)
							);
							lastIndexSaved = k;
						}
						if(isNaN(reverseData[k].ctr)) {
							ctr += 0;
						}
						clic += reverseData[k].clicks;
						impressions += reverseData[k].impressions;
						ctr += reverseData[k].ctr;
						count++;
					}
				}
				// Retrieve the last element (the data are given by date and only the lastest one interest us (for each month))
				lastPos = allPos.pop();
				if(lastPos == 0 || isNaN(lastPos)) {
					sortedKeyword.data.push({
						month: sortedMonth[y],
						pos: 0,
						clicks: Number.parseFloat(clic).toFixed(2),
						imp: Number.parseFloat(impressions).toFixed(2),
						ctr: Number.parseFloat(ctr / count).toFixed(2)
					});
				}
				else{
					sortedKeyword.data.push({
						month: sortedMonth[y],
						pos: Number.parseFloat(lastPos).toFixed(2),
						clicks: Number.parseFloat(clic).toFixed(2),
						imp: Number.parseFloat(impressions).toFixed(2),
						ctr: Number.parseFloat(ctr / count).toFixed(2)
					});
				}
			}

			// GET ARRAY OF POSITION FOR CHART
			for(var z = 0; z < sortedKeyword.data.length; z++) {
				keywordYearlyPos.pos.push(sortedKeyword.data[z].pos);
				keywordYearlyPos.clicks.push(sortedKeyword.data[z].clicks);
				keywordYearlyPos.imp.push(sortedKeyword.data[z].imp);
				keywordYearlyPos.ctr.push(sortedKeyword.data[z].ctr);
			}
			return keywordYearlyPos;
		},

		/**
		 * Sort the keywords requested and ignore the one that isn't in the list (top keyword is the list)
		 * @param {Array<object>} data - Array of keyword data
		 * @param {Array<string>} keywordList - List of keyword to check
		 * @return {Array<object>} Return all informations for topKeywords only
		 */
		sortTopKeywords: (data, keywordList) => {
			let topKeywordData = [];
			let keywordListLower = keywordList.map(v => v.toLowerCase());
			if(keywordListLower.length > 0) {
				for(var i = 0; i < data.length; i++) {
					if(keywordListLower.includes(data[i].keys[0])) {
						topKeywordData.push(data[i]);
						let index = keywordListLower.indexOf(data[i].keys[0]);
						keywordListLower.splice(index, 1);
					}
				}
			}
			return topKeywordData;
		},

		/**
		 * Sort the given data to retrieve the statistic made by THE BRAND only
		 * @param {Array<object>} data - Array of keyword data
		 * @param {string} brandName - Name of the brand
		 * @return {Array<object>} Return all informations for the brand
		 */
		sortDataForBrand: (data, brandName) => {
			let ctr = 0;
			let imp = 0;
			let position = 0;
			let clicks = 0;
			let count = 0;
			let finalData = [];
			let brand = brandName
				.toLowerCase()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "")
				.split(" ")
				.join(",")
				.split("'")
				.join(",")
				.split(",");
			let nonUsableName = [
				"de",
				"ma",
				"la",
				"le",
				"les",
				"des",
				"mes",
				"tes",
				"par"
			];
			// REMOVE ARTICLE FROM BRAND
			for(var i = 0; i < nonUsableName.length; i++) {
				if(brand.indexOf(nonUsableName[i]) > -1) {
					let indexToRemove = brand.indexOf(nonUsableName[i]);
					brand.splice(indexToRemove, 1);
				}
			}
			if(data) {
				for(var i = 0; i < data.length; i++) {
					let keywordToCompare = data[i].keys[0].split(" ");
					if(brand.every(v => keywordToCompare.includes(v))) {
						ctr += data[i].ctr;
						imp += data[i].impressions;
						clicks += data[i].clicks;
						position += data[i].position;
						count++;
					}
				}
				finalData.push(imp, clicks, ctr / count, position / count);
				return finalData;
			}
		},

		/**
		 * @param {Array} arguments[0] Data to sort
		 * @param {Array} arguments[x] Arguments arrays to sort data
		 * @param {String} arguments[x][0] Name of the property to sort
		 * @param {Boolean} arguments[x][1] False: Ascending, True: Descending
		 * @returns {Array}
		 */
		sortByArgsName(){
			//console.log("sortByArgsName", arguments.length);
			if(arguments.length > 1){
				Timsort.sort(arguments[0], (a, b) => {
					for(let i = 1; i < arguments.length; i++){
						if(arguments[i][1]){
							if(a[arguments[i][0]] < b[arguments[i][0]]){
								return 1;
							}
							else if(a[arguments[i][0]] > b[arguments[i][0]]){
								return -1;
							}
							else{
								continue;
							}
						}
						else{
							if(a[arguments[i][0]] > b[arguments[i][0]]){
								return 1;
							}
							else if(a[arguments[i][0]] < b[arguments[i][0]]){
								return -1;
							}
							else{
								continue;
							}
						}
					}
					return 0;
				});
				return arguments[0];
			}
			else if(arguments.length == 1){
				return arguments[0];
			}
			else{
				throw "Sort failed: you must at least have 1 argument.";
			}
		},
	}
};
